<template>
  <div>
    <CustomCallout
      class="mt-2 deep"
      :has-toggle="true"
      :openned="showStudents"
      @click:open="toggleStudents"
    >
      <template #default>
        <div class="row py-2">
          <div class="col-1">
            <i class="fa-stack icon-circle p-2">
              <i
                class="fas fa-circle fa-stack-2x icon-circle-stack color-orange"
              />
              <i class="fas fa-user fa-stack-1x fa-inverse" />
            </i>
          </div>
          <div class="col-3">
            <div class="info-text-title text-gray">Nombre del Asistente:</div>
            <span>{{ value.assistantName }}</span>
          </div>
          <div class="col-3">
            <div class="info-text-title text-gray">Cantidad de Matrícula:</div>
            <span>{{ value.matriculatedAmount }}</span>
          </div>
          <div class="col-3">
            <div class="info-text-title text-gray">Necesidades Asignadas:</div>
            <span>{{ value.necesitiesAssigned }}</span>
          </div>
        </div>
      </template>
      <template #edition>
        <div class="p-2">
          <div
            v-for="student in value.students"
            :key="student.studentSieId"
            class="row bg-white mx-1 my-2 px-2 py-3"
          >
            <div class="col-3">
              <div class="info-text-title text-gray">
                Nombre del Estudiante:
              </div>
              <span>{{ student.fullName }}</span>
            </div>
            <div class="col-1">
              <div class="info-text-title text-gray">Grado:</div>
              <span>{{ student.grade }}</span>
            </div>
            <div class="col-3">
              <div class="info-text-title text-gray">Impedimento:</div>
              <span>{{ student.impediment }}</span>
            </div>
            <div class="col-1">
              <div class="info-text-title text-gray">Edad:</div>
              <span>{{ student.age }}</span>
            </div>
            <div class="col-2">
              <div class="info-text-title text-gray">Nombre del Maestro:</div>
              <span>{{ student.teacherName }}</span>
            </div>
            <div class="col-2">
              <div class="info-text-title text-gray">Ruta:</div>
              <span>{{ student.route }}</span>
            </div>
          </div>
        </div>
      </template>
    </CustomCallout>
  </div>
</template>

<script>
import CustomCallout from "custom-callout";

export default {
  name: "SchoolInfoRow",
  components: {
    CustomCallout
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showStudents: false
    };
  },
  methods: {
    toggleStudents() {
      this.showStudents = !this.showStudents;
    }
  }
};
</script>
